import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { DialogActionsBar as KDialogActionsBar } from '@progress/kendo-vue-dialogs';
import { Button as KButton } from '@progress/kendo-vue-buttons';
import { StackLayout as KStackLayout } from '@progress/kendo-vue-layout';
import useTranslations from '@/composables/useTranslations';
import { useMagicKeys } from '@vueuse/core';
import { computed, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DialogActionsBar',
  props: {
    confirmButtonText: { default: undefined },
    confirmButtonDisabled: { type: Boolean, default: false },
    confirmButtonVisible: { type: Boolean, default: true },
    cancelButtonText: { default: undefined },
    cancelButtonDisabled: { type: Boolean, default: false },
    layout: { default: 'end' }
  },
  emits: ["cancel", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const kendoLayout = computed(() => (props.layout === 'space-between' ? 'start' : props.layout));

const { translate: t } = useTranslations();
const keys = useMagicKeys();
const shiftCtrlC = keys['Alt+C']; // cancel action
const shiftCtrlS = keys['Alt+S']; // confirm action (save)

watch(shiftCtrlC, (value) => {
  if (value) emit('cancel');
});

watch(shiftCtrlS, (value) => {
  if (value) emit('confirm');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(KDialogActionsBar), {
    layout: kendoLayout.value,
    class: _normalizeClass({ 'dialog-actions-bar--space-between': __props.layout === 'space-between' })
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "leftSectionTemplate"),
      _createVNode(_unref(KStackLayout), { gap: 8 }, {
        default: _withCtx(() => [
          _createVNode(_unref(KButton), {
            "data-testid": "dialog-cancel-btn",
            size: 'large',
            "fill-mode": 'flat',
            "theme-color": 'secondary',
            type: 'cancel',
            disabled: __props.cancelButtonDisabled,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel'))),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (emit('cancel')), ["enter"]))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.cancelButtonText ?? _unref(t)('Cancel')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _renderSlot(_ctx.$slots, "confirmButtonTemplate"),
          (!_ctx.$slots.confirmButtonTemplate && __props.confirmButtonVisible)
            ? (_openBlock(), _createBlock(_unref(KButton), {
                key: 0,
                "data-testid": "dialog-confirm-btn",
                size: 'large',
                "fill-mode": 'flat',
                "theme-color": 'primary',
                type: 'submit',
                disabled: __props.confirmButtonDisabled,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('confirm'))),
                onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (emit('confirm')), ["enter"]))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.confirmButtonText ?? _unref(t)('Common.Confirm')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["layout", "class"]))
}
}

})